export default __webpack_public_path__ + "static/media/Family_32.7c89e5e3.svg";